<div class="cancel-request">
  <div class="mb-16">
    <h1>Anulação de pedido</h1>
  </div>

  <div class="fields">
    <div class="mb-16">
      <label for="description-textarea">Descrição</label>
      <scc-dsm3-textarea-control
        id="description-textarea"
        [formGroup]="formGroup"
        placeholder="Observações"
        [maxlength]="9999"
        formName="description"
      >
      </scc-dsm3-textarea-control>
    </div>

    <div class="mb-16">
      <label for="attachments-upload">Anexos</label>
      <scc-dsm3-multi-upload-control
        id="attachments-upload"
        [formGroup]="formGroup"
        formName="attachments"
        [fileTypes]="fileTypes"
        [fileSizeLimit]="3670016"
      >
      </scc-dsm3-multi-upload-control>
    </div>
  </div>

  <div class="button-wrapper">
    <button class="btn-white-bggrey" (click)="onClickCancel()">Cancelar</button>

    <button class="btn-primary-yellow" (click)="onClickSubmit()" [disabled]="!formGroup?.valid">Enviar</button>
  </div>
</div>
